// extracted by mini-css-extract-plugin
export default {"input":"Input_input__Ba4RU","tip":"Input_tip__rugoX","isPlaceholder":"Input_isPlaceholder__PaMpP","inputElem":"Input_inputElem__jVcD+"};